export const DELIVERY_TIME = 'delivery_time';
export const GLOVES = 'GlovesRecommendedUses';
// e_s_kollektionslinie from PIM:
export const COLLECTION_LINE = ['Kollektionslinie', 'e_s_kollektionslinie'];
export const SIZE = 'size';
export const COLOUR = 'hue';
export const GENDER = ['gender', 'geschlecht'];